import React from 'react';
import './WhyChooseUs.css';

function WhyChooseUs() {
  return (
    <section className="why-choose-us">
      <h2>Why Choose Klyzen Ventures?</h2>
      <div className="features-grid">
        <div className="feature-box">
          <h3>🚀 Future-Ready</h3>
          <p>We operate at the intersection of innovation and industry, preparing businesses for tomorrow.</p>
        </div>
        <div className="feature-box">
          <h3>💡 Multi-Domain Expertise</h3>
          <p>From tech to training, we bridge traditional sectors with emerging tech effortlessly.</p>
        </div>
        <div className="feature-box">
          <h3>🤝 Startup-Friendly</h3>
          <p>Whether you're scaling or starting, our ecosystem supports growth with mentorship and agility.</p>
        </div>
      </div>
    </section>
  );
}

export default WhyChooseUs;
